import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex gap-3"
};
const _hoisted_2 = ["src"];
import { computed } from "vue";
import { FileUpload } from "primevue";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImageLoader',
    props: {
        modelValue: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: true
        }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const urls = computed(() => props.modelValue);
        const isDisabled = computed(() => {
            if (props.multiple == true) {
                return false;
            }
            return urls.value.length >= 1;
        });
        async function upload(event) {
            const file = event.files[0];
            const uploadedFile = await store.dispatch("files/uploadFile", file);
            const newUrls = [...urls.value, uploadedFile.name];
            emit("update:modelValue", newUrls);
        }
        function deleteImage(index) {
            const newUrls = urls.value.filter((_, i) => i !== index);
            emit("update:modelValue", newUrls);
        }
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(FileUpload), {
                    ref: "fileupload",
                    "show-upload-button": false,
                    disabled: isDisabled.value,
                    mode: "basic",
                    accept: "image/*",
                    "max-file-size": 1000000,
                    "custom-upload": "",
                    multiple: __props.multiple,
                    auto: "",
                    onSelect: upload
                }, {
                    empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("span", null, "Drag and drop file to here to upload.", -1)
                        ]))]),
                    _: 1
                }, 8, ["disabled", "multiple"]),
                (urls.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urls.value, (url, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "relative mt-2"
                            }, [
                                _createElementVNode("img", {
                                    src: url,
                                    alt: "Image",
                                    class: "shadow-md rounded-xl w-full sm:w-32"
                                }, null, 8, _hoisted_2),
                                _createVNode(_component_UIcon, {
                                    class: "close-icon",
                                    icon: "/svg/light/close.svg",
                                    onClick: ($event) => (deleteImage(index))
                                }, null, 8, ["onClick"])
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
